
const digest = '6e8dcc5292637a7fd549ec8f84fb9d7d371a1f8873346631402b910fa63f0fba';
const classes = {"wrapper":"_wrapper_h3dbe_1","overviewWrapper":"_overviewWrapper_h3dbe_9"};
const css = `._wrapper_h3dbe_1 {
  display: flex;
  font-family: Rubik, "sans-serif";
  flex-direction: column;
  gap: 15px;
  overflow-y: scroll;
}

._overviewWrapper_h3dbe_9 {
  font-family: "Rubik", sans-serif;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  border: 1px solid #eaedf3;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  